import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import getCreditCardType from "../grohe/groheCart/getCreditCardType";
import {onInputBlur, onInputChange, useInputsValidation} from "./inputFunctions";


const LookInput = (props) => {

  const {property, inputValue, setInputValue, intl, errorsObject, changeErrorsObject, getValidationErrors,
    inputsValidated, isRequired, blockClassName, name} = props;

  const onBlur = (event) => {
    onInputBlur(event, property, setInputValue, errorsObject, changeErrorsObject, getValidationErrors);
  };

  const onChange = (event) => {
    onInputChange(event, property, setInputValue, errorsObject, changeErrorsObject, getValidationErrors);
  };

  useInputsValidation(inputsValidated, onBlur, inputValue);

  const errorsExist = errorsObject && Array.isArray(errorsObject[property]) && !!errorsObject[property].length;

  const type = property !== "email" && property !== "password" ? "text" : property;

  if (property === "cardNumber") {
    return (
      <div className="look-block">
        <FormControl variant="outlined" size="small">
          <InputLabel htmlFor="property">
            <FormattedMessage id={"look.inputs." + property}/>
          </InputLabel>
          <OutlinedInput className="look-input"
                         id={property}
                         type={type}
                         value={inputValue}
                         required={isRequired}
                         endAdornment={property === "cardNumber" ? (
                           <InputAdornment position="end">
                             {getCreditCardType(inputValue).icon}
                           </InputAdornment>
                         ) : null}
                         label={intl.formatMessage({id: "look.inputs." + property})}
                         onChange={onChange}
                         onBlur={onBlur}
                         error={errorsExist}
                         variant="outlined" />
          {errorsExist ? (
            <FormHelperText className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained">
              <FormattedMessage id={errorsObject[property][0]}/>
            </FormHelperText>
          ) : null}
        </FormControl>
      </div>
    )
  }

  return (
    <div className={"look-block" + (blockClassName ? " " + blockClassName : "")}>
      <TextField className="look-input"
                 type={type}
                 value={inputValue}
                 required={isRequired}
                 size="small"
                 name={name || property || null}
                 label={intl.formatMessage({id: "look.inputs." + property})}
                 onChange={onChange}
                 onBlur={onBlur}
                 error={errorsExist}
                 helperText={
                   errorsExist ? intl.formatMessage({id : errorsObject[property][0]}): ""
                 }
                 variant="outlined" />
    </div>
  )
};

LookInput.propTypes = {
  property: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  // validation below
  inputsValidated: PropTypes.bool,
  errorsObject: PropTypes.object, // userInfoErrorsLike
  changeErrorsObject: PropTypes.func,
  getValidationErrors: PropTypes.func,
  blockClassName: PropTypes.string,
};

export default injectIntl(LookInput)
